import React, { useState, useEffect, useCallback } from 'react';
import Div100vh from 'react-div-100vh';
import { getAwardsData } from 'services/authService';
import MultiStepForm from './Step/MultiStepForm';

export default function Giveaway() {
    let mounted = true;
    const [ awardsData, setAwardsData ] = useState([]);

    const fetchawardsData = useCallback(async() => {
        let result = await getAwardsData();
        if(mounted){
            setAwardsData(result.awards_list);
        }
    }, [])

    useEffect(() => {
        fetchawardsData();
        return () => mounted = false;
    }, [])

    return (<>
        <div className="inner-bg"></div>
        <div className="inner-page giveaway-page">
            <MultiStepForm awardsData={awardsData} fetchawardsData={fetchawardsData} />
        </div>
    </>)
}